/** @jsxRuntime classic */
/** @jsx jsx */

export const bp = {
  xs: 576,
  sm: 768,
  md: 992,
  lg: 1200,
};

const bpH = {
  xs: 400,
};

export const queries = {
  xs: `(min-width: ${bp.xs}px)`,
  sm: `(min-width: ${bp.sm}px)`,
  md: `(min-width: ${bp.md}px)`,
  lg: `(min-width: ${bp.lg}px)`,
  pt: `(orientation: portrait)`,
  ls: `(orientation: landscape)`,
};

export const mq = (n) => {
  const bpArray = Object.keys(bp).map((key) => [key, bp[key]]);

  const [result] = bpArray.reduce((acc, [name, size]) => {
    if (n === name) return [...acc, `@media (min-width: ${size}px)`];
    return acc;
  }, []);

  return result;
};

export const mqH = (n) => {
  const bpArray = Object.keys(bpH).map((key) => [key, bpH[key]]);

  const [result] = bpArray.reduce((acc, [name, size]) => {
    if (n === name) return [...acc, `(min-height: ${size}px)`];
    return acc;
  }, []);

  return result;
};

export const mqLandscape = `@media (orientation: landscape)`;

/*render(
    <div>
      <div
        css={{
          color: 'green',
          [mq[0]]: {
            color: 'gray'
          },
          [mq[1]]: {
            color: 'hotpink'
          }
        }}
      >
        Some text!
      </div>
      <p
        css={css`
          color: green;
          ${mq[0]} {
            color: gray;
          }
          ${mq[1]} {
            color: hotpink;
          }
        `}
      >
        Some other text!
      </p>
    </div>
  )*/
